import { IDanhSachMoMonRequest } from "./../../reducer-model/lop-tin-chi/IDanhSachMoMonReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachMoMonActionsObj = {
  CHANGE_FILTER: {} as any,

  EXPORT_EXCEL_START: {} as IDanhSachMoMonRequest,
  EXPORT_EXCEL_SUCCESS: "",
  EXPORT_EXCEL_ERROR: "",
};

export const eDanhSachMoMonActionIds = generateActionTypeIds(
  eDanhSachMoMonActionsObj,
  "DANH_SACH_MO_MON"
);
export type IDanhSachMoMonActions = IGenericActionType<
  typeof eDanhSachMoMonActionsObj,
  "DANH_SACH_MO_MON"
>;
